import { DetailsPanelType, useDetailsPanelsActions } from "PFApp/booking/components/details_panel";
import { useIsReassignAllowed } from "PFApp/booking/components/details_panel/detail_view/reassign_side_panel/hooks/use_is_reassign_allowed";
import { Button } from "PFComponents/button";
import { Booking } from "PFTypes";

type ReassignButtonProps = {
  booking: Booking;
  title?: string;
};

export const ReassignButton = ({ booking, title }: ReassignButtonProps) => {
  const { openDetailsPanel } = useDetailsPanelsActions();
  const { isReassignAllowed } = useIsReassignAllowed({ bookingIds: [booking.id] });

  if (!isReassignAllowed) {
    return null;
  }

  return (
    <Button
      title={title}
      icon="reassign"
      onClick={() => {
        openDetailsPanel({
          type: DetailsPanelType.Reassign,
          id: DetailsPanelType.Reassign,
          reassignDetails: {
            bookingIds: [booking.id]
          }
        });
      }}
      kind="secondary"
    />
  );
};
